import { useGet } from "../hooks";
import Navbar from "../navbar";
import Footer from "../footer";
import { SRLWrapper } from "simple-react-lightbox";
import React, { useState, useEffect } from "react";

const options = {
  buttons: {
    showDownloadButton: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
  },
};

function Charts() {
  const [selectOption, setSelectOption] = useState(0);

  const chartsURL =
    "https://stetor16.dreamhosters.com/wp-json/wp/v2/graphs_and_charts?per_page=100";

  const [data, loading] = useGet(chartsURL);

  const categoryURL =
    "https://stetor16.dreamhosters.com/wp-json/wp/v2/all-terms?term=chart_category";

  const [categories] = useGet(categoryURL);

  const items = Object.values(categories);

  useEffect(() => {
    //sets select option value on mount
    setSelectOption("");
  }, []);

  return (
    <>
      <Navbar />
      {loading ? (
        "loading categories..."
      ) : (
        <div className="charts__page-container pt-5">
          <div className="charts__heading-selection-box text-center">
            <h2 className="site__subheading">Select Charts Category</h2>
            <select
              onChange={(e) => setSelectOption(e.target.value)}
              className="select__options-container"
            >
              <option value="" className="option__item-name site__paragraph">
                All
              </option>

              {items.map((item, name) => {
                return (
                  <option
                    key={name}
                    value={item.term_id}
                    className="option__item-name site__paragraph"
                  >
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
          <SRLWrapper options={options}>
            <ul className="row charts__info-box">
              {data.map((d) => {
                let matchingCategory = false;
                if (selectOption != "" && d.chart_category.length > 0) {
                  for (let i = 0; i < d.chart_category.length; i++) {
                    if (d.chart_category[i] == selectOption) {
                      matchingCategory = true;
                    }
                  }
                }

                //if both are false, it doesnt execute
                //if either is true then execute whatever is in the if statement
                if (matchingCategory || selectOption === "") {
                  return (
                    <li key={d.id} className=" text-center  m-3 ">
                      <img
                        className="charts__chart-image"
                        src={d.acf.chart_image.sizes.large}
                        alt="charts"
                      />
                    </li>
                  );
                } else {
                  return false;
                }
              })}
            </ul>
          </SRLWrapper>
        </div>
      )}
      <Footer />
    </>
  );
}
export default Charts;
